import React from 'react';
import { createRoot } from 'react-dom/client';
import './app.css';
import { App } from './App.jsx';

createRoot(document.querySelector('#saveflow-root')).render(
    <App />,
);
